const refreshing = new Map();

export function requestSessionRefresh(client, refresh) {
  if (!refreshing.has(refresh)) {
    const request = client.request({ url: "/RefreshSession", method: "post", timeout: 15000, data: { refresh } }).then((res) => res.data);
    const pending = request.finally(() => { if (refreshing.get(refresh) === pending) refreshing.delete(refresh); });
    refreshing.set(refresh, pending);
  }
  return refreshing.get(refresh);
}

export function accessNeedsRenewal(token, now = Date.now()) {
  try {
    const part = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(part));
    return Number.isFinite(exp) && exp * 1000 <= now + 60000;
  } catch { return false; }
}

// Called before protected requests, so waking a suspended app cannot race refresh.
export function createSessionGate({ getUser, renew, accept, expire }) {
  let active;
  return async function ensureSession({ force = false, token } = {}) {
    const user = getUser();
    if (!user?.refreshToken || (!force && !accessNeedsRenewal(user.token))) return;
    if (force && token && token !== user.token) return; // Another request already renewed it.
    if (active?.refresh === user.refreshToken) return active.promise;
    const unchanged = () => {
      const current = getUser();
      return current?.id === user.id && current?.refreshToken === user.refreshToken;
    };
    const promise = (async () => {
      try {
        const response = await Promise.resolve().then(() => renew(user.refreshToken));
        if (!unchanged()) throw new Error("Sesiunea s-a schimbat. Reîncearcă din contul curent.");
        if (!response?.user?.token || !response?.user?.refreshToken) {
          const error = new Error("Sesiunea a expirat. Autentifică-te din nou.");
          error.response = { status: 401 }; throw error;
        }
        accept(response);
      } catch (error) {
        if (unchanged() && [400, 401, 403].includes(error.response?.status)) expire();
        throw error;
      } finally { if (active?.promise === promise) active = null; }
    })();
    active = { refresh: user.refreshToken, promise };
    return promise;
  };
}
